<template>
	<div class="SidebarLayout-styles-content">

    <div class="AccountHistoryDesktop-styles-container">
      <div class="AccountHistoryTabs-styles-wrapper">
        <div class="AccountHistoryTabs-styles-dates-wrapper">
          <div class="AccountHistoryTabs-styles-flex-column AccountHistoryTabs-styles-margin-right">
            <span class="AccountHistoryTabs-styles-label">Period:</span>
            <div class="InputGroup-styles-input-group AccountHistoryTabs-styles-input-group">
              <div class="InputGroup-styles-input-wrapper">
                <select name="timePeriod" v-model="timeperiod">
                <option :value="mon.date" v-for="mon in filterMonths">{{ mon.name }}</option>
              </select></div>

              <date-picker v-if="timeperiod === 'range'" v-model="time1" :format="'YYYY-MM-DD'" range></date-picker>
              <ul class="InputMessages-styles-input-messages"></ul>
              <ul class="InputWarnings-styles-input-messages"></ul>
            </div>
          </div>
        </div>
        <div class="AccountHistoryTabs-styles-date-restriction-wrapper">
          <span id="contact-info" class="AccountHistoryTabs-styles-date-restriction">To retrieve records older than 6 months, please contact us.</span>
        </div>
      </div>
      <div class="AccountHistoryDesktop-styles-content-wrapper">
        <div v-if="notfound" class="alert alert-info">
          {{ t.error.notfound_content_list }}
        </div>
        <div class="AccountHistoryTable-styles-account-history">
          <table class="AccountHistoryTable-styles-table" v-if="!notfound">
            <thead>
            <tr>
              <th>
                {{ t.betting.title.status }}
              </th>
              <th>
                {{ t.betting.title.date }}
              </th>
              <th class="text-right">

              </th>
              <th class="text-right">
                {{ t.transactions.amount }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="transaction in transactions">
              <td class="nowrap">
                <template v-if="transaction.status == 'Pending'">
                  <span class="status-pill blue smaller"></span><span>{{ t.transactions.status.pending }}</span>
                </template>
                <template v-if="transaction.status == 'Processed'">
                  <span class="status-pill yellow smaller"></span><span>{{ t.transactions.status.processed }}</span>
                </template>
                <template v-if="transaction.status == 'Faıled'">
                  <span class="status-pill red smaller"></span><span>{{ t.transactions.status.failed }}</span>
                </template>
              </td>
              <td class="text-left">
                {{ transaction.addedAt | moment('D MMM ddd', session.timezone) | slimiter(10) }}
              <span class="smaller lighter">
						    {{ transaction.addedAt | moment('HH:mm', session.timezone) | slimiter(10) }}
					    </span>
              </td>
              <td class="text-left bolder nowrap">
                <span>{{ transaction.info }}</span>
              </td>
              <td class="text-right bolder nowrap">
                <span :class="(transaction.type.operator === '+') ? 'text-success' : 'text-danger'">{{ transaction.type.operator }} {{ transaction.amount | toMoney(transaction.currency) }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>


    </div>

		<paginate v-if="pagination" class="mx-3"
		          :page-count="pagination.pageCount"
		          :page-range="pagination.pageRange"
		          :force-page="(pagination.current-1)"
		          :initialPage="(pagination.current-1)"
		          :margin-pages="2"
		          :click-handler="onChangePage"
		          :prev-text="t.previous"
		          :next-text="t.next"
		          :container-class="'pagination float-right'"
		          :page-class="'page-item'"
		          :page-link-class="'page-link'"
		          :prev-class="'page-item'"
		          :prev-link-class="'page-link'"
		          :next-class="'page-item'"
		          :next-link-class="'page-link'"
		>
		</paginate>
	</div>
</template>

<script>

    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    import Paginate from 'vuejs-paginate'
    export default {
        name: 'transactionDeposit',
	    components: { Paginate, DatePicker },
        data () {
            return {
                time1: null,
                session: session,
                pagination: null,
                t: this.$root.t,
                notfound: false,
                transactions: null,
                type: 'deposit_money',
                filterMonths: this.getLastXMonths(),
                timeperiod: {from: this.getLastXMonths()[0]['from'], to: this.getLastXMonths()[0]['to']}
            }
        },
        watch: {
            'time1' (d) {
              console.log(d);
              this.fetchTransactions({from: moment(d[0]).format("YYYY-MM-DD"), to: moment(d[1]).format("YYYY-MM-DD")})
            },
            'timeperiod' () {
                this.fetchTransactions()
            },
            '$route' () {
                this.fetchTransactions();
            },
        },
	    mounted () {

            this.fetchTransactions();
            this.filterMonths.push({date: 'range', name: 'Others'})
	    },
	    methods: {
            onChangePage (page) {
                this.pagination.current = page;
                this.$router.push({ query: {page: page} });
	            window.scroll(0, 0);
            },
            fetchTransactions (date) {
                console.log(date);
                this.$http.get(api+'api/v1/user/transactions', {params:  {rangeDateTime: ( date ) ? date : {from: this.timeperiod, to: moment(this.timeperiod).format("YYYY-MM-") + moment().daysInMonth()}, status: this.$route.query.status, page: this.$route.query.page }})
                    .then(response => {

                        this.pagination = response.body.result.pagination;

                        this.transactions = response.body.result.transactions;
                        this.$bus.$emit('globalLoader', 0);
                        this.notfound = false;
                    }, response => {
                        this.$bus.$emit('globalLoader', 0);
                        this.notfound = true;
                    })
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/transactions/transactionDeposit.vue